import styled from 'styled-components';

export const Container = styled.div`
	--size: ${props => (props.size === 'large' ? '0.5rem' : '0.25rem')};
	--color: ${props => props.color || 'currentColor'};
	--speed: ${props => props.speed || '1s'};

	/* position: absolute; */
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		width: var(--size);
		height: var(--size);
		border-radius: 100%;
		margin: 0 ${props => (props.size === 'large' ? '0.25rem' : '0.125rem')};
		background: var(--color);
		animation: steps var(--speed) cubic-bezier(0.32, 0.94, 0.6, 1) infinite;
	}
	span:nth-child(2) {
		animation-delay: calc(var(--speed) / 3);
	}
	span:nth-child(3) {
		animation-delay: calc(var(--speed) / 3 * 2);
	}

	@keyframes steps {
		0%,
		66%,
		100% {
			transform: initial;
		}
		30% {
			transform: translateY(
				${props => (props.size === 'large' ? '-0.25rem' : '-0.125rem')}
			);
		}
	}
`;
